/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:d1bdbf69-f47e-4a0a-af6b-e51aa18c3fa8",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_wCAcjMBAq",
    "aws_user_pools_web_client_id": "5hepi5ie12qo66uf4q4o0iqsqh",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "teamvisresults225643-lite",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "step1",
            "endpoint": "https://0o66nv8s7k.execute-api.ap-northeast-1.amazonaws.com/lite",
            "region": "ap-northeast-1"
        },
        {
            "name": "lite1",
            "endpoint": "https://jdqpmpxzgk.execute-api.ap-northeast-1.amazonaws.com/lite",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
